import PropTypes from 'prop-types';

import Container from '../../../Core/Container';
import RichText from '../../../Core/RichText';
import OptimumStoresCollection from '../OptimumStoresCollection';
import Disclaimer from '../../Disclaimer';

import { Wrapper, ContentWrapper, Content, Stores, StyledCtas } from './styles';

const OptimumStoresBanner = ({ className = '', data }) => {
  if (!data) return null;

  const {
    component,
    heading,
    bodyCopy,
    disclaimer,
    stores,
    ctas,
    backgroundColor,
  } = data;

  return component === 'pc-optimum-store-banner' ? (
    <Container>
      <Wrapper
        backgroundColor={backgroundColor}
        className={`${className} ${component}`}
      >
        <ContentWrapper>
          <Content>
            {heading && <RichText document={heading} />}
            {bodyCopy && <RichText document={bodyCopy} />}
          </Content>
          {disclaimer && <Disclaimer data={disclaimer} alignment="left" />}
        </ContentWrapper>
        <Stores>
          <OptimumStoresCollection stores={stores} />
        </Stores>
        {ctas && <StyledCtas ctas={ctas} direction="row" />}
      </Wrapper>
    </Container>
  ) : (
    <Container>
      <Wrapper
        backgroundColor={backgroundColor}
        className={`${className} ${component}`}
      >
        <ContentWrapper>
          <Content>
            {heading && <RichText document={heading} />}
            {bodyCopy && <RichText document={bodyCopy} />}
          </Content>
          {ctas && <StyledCtas ctas={ctas} direction="row" />}
          {disclaimer && component === 'pc-optimum-store-accordion' ? (
            <Disclaimer data={disclaimer} />
          ) : (
            <Disclaimer data={disclaimer} alignment="left" />
          )}
          <Stores>
            <OptimumStoresCollection stores={stores} component={component} />
          </Stores>
        </ContentWrapper>
      </Wrapper>
    </Container>
  );
};

OptimumStoresBanner.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape().isRequired,
};

export default OptimumStoresBanner;
